import React, { lazy } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import * as Icon from '@ant-design/icons';
import { ProtectedRoute } from '@components';

const BusinessEntity = lazy(() => import('@/modules/contractManageV5/businessEntity'));
const SealManage = lazy(() => import('@/modules/contractManageV5/sealManage'));
const ContractConfig = lazy(() => import('@/modules/contractManageV5/contractConfig'));
const ContractTemplate = lazy(() => import('@/modules/contractManageV5/contractTemplate'));
const EditContractTemplate = lazy(() => import('@modules/contractManageV5/contractTemplate/fddV5'));
const FilingContracts = lazy(() => import('@/modules/contractManageV5/filingContracts'));

export default {
  path: 'contractManageV5',
  element: <Outlet />,
  options: {
    title: '合同管理V5',
    permissionKey: 'menu-contractManageV5',
    key: 'menu-contractManageV5',
    icon: <Icon.ContactsOutlined />,
    link: '/contractManageV5',
    displayInMenu: false,
    // allowAccess: true,
  },
  children: [
    {
      path: 'businessEntity',
      element: <Outlet />,
      options: {
        title: '企业主体V5',
        key: 'menu-contractManageV5-businessEntity',
        icon: <Icon.FileOutlined />,
        link: '/contractManageV5/businessEntity',
      },
      children: [
        {
          index: true,
          element: <ProtectedRoute title="企业主体V5" permissionKey="menu-contractManageV5-businessEntity" component={<BusinessEntity />} />,
        },
      ],
    },
    {
      path: 'sealManage',
      element: <Outlet />,
      options: {
        title: '印章管理V5',
        key: 'menu-contractManageV5-sealManage',
        icon: <Icon.FileOutlined />,
        link: '/contractManageV5/sealManage',
      },
      children: [
        {
          index: true,
          element: <ProtectedRoute title="印章管理V5" permissionKey="menu-contractManageV5-sealManage" component={<SealManage />} />,
        },
      ],
    },
    {
      path: 'contractConfig',
      element: <Outlet />,
      options: {
        title: '合同配置V5',
        key: 'menu-contractManageV5-contractConfig',
        icon: <Icon.FileOutlined />,
        link: '/contractManageV5/contractConfig',
      },
      children: [
        {
          index: true,
          element: <ProtectedRoute title="合同配置V5" permissionKey="menu-contractManageV5-contractConfig" component={<ContractConfig />} />,
        },
      ],
    },
    {
      path: 'contractTemplate',
      element: <Outlet />,
      options: {
        title: '合同模板V5',
        key: 'menu-contractManageV5-contractTemplate',
        icon: <Icon.FileOutlined />,
        link: '/contractManageV5/contractTemplate',
      },
      children: [
        {
          index: true,
          element: <ProtectedRoute title="合同模板V5" permissionKey="menu-contractManageV5-contractTemplate" component={<ContractTemplate />} />,
        },
        {
          path: ':contractTempId/edit',
          element: <ProtectedRoute title="编辑合同模板V5" permissionKey="menu-contractManageV5-contractTemplate" component={<EditContractTemplate />} />,
        },
      ],
    },
    {
      path: 'memberContract',
      element: <Outlet />,
      options: {
        title: '会员合同V5',
        key: 'menu-contractManageV5-memberContract',
        icon: <Icon.FileOutlined />,
        link: '/contractManageV5/memberContract',
      },
      children: [
        {
          index: true,
          element: <Navigate to="/contractMannage/v5MemberContract" replace />,
        },
      ],
    },
    {
      path: 'filingContracts',
      element: <Outlet />,
      options: {
        title: '归档合同V5',
        key: 'menu-contractManageV5-filingContracts',
        icon: <Icon.FileOutlined />,
        link: '/contractManageV5/filingContracts',
      },
      children: [
        {
          index: true,
          element: <ProtectedRoute title="归档合同V5" permissionKey="menu-contractManageV5-filingContracts" component={<FilingContracts />} />,
        },
      ],
    },
  ],
};
